import React, { useEffect, useRef, useState } from 'react';

export default function Window({ id, title, url, zIndex, onClose, onFocus, initial = {}, minimized=false }) {
  const ref = useRef();
  const [pos, setPos] = useState({ x: initial.x || 120, y: initial.y || 80 });
  const [size, setSize] = useState({ w: initial.w || 800, h: initial.h || 600 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isMinimized, setIsMinimized] = useState(minimized);

  useEffect(() => {
    function onMove(e) {
      if (!dragging) return;
      setPos({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    }
    function onUp() { setDragging(false); }
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
  }, [dragging, offset]);

  // resize handle
  function startDrag(e) {
    const rect = ref.current.getBoundingClientRect();
    setOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    setDragging(true);
    onFocus(id);
  }

  function onTitleDown(e) {
    const rect = ref.current.getBoundingClientRect();
    setOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    setDragging(true);
    onFocus(id);
    e.preventDefault();
  }

  function onResizeStart(e) {
    e.stopPropagation();
    const startX = e.clientX; const startY = e.clientY; const startW = size.w; const startH = size.h;
    function onMove(e2) {
      setSize({ w: Math.max(300, startW + (e2.clientX - startX)), h: Math.max(200, startH + (e2.clientY - startY)) });
    }
    function onUp() { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); }
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }

  return (
    <div
      ref={ref}
      className={`window-root ${isMinimized ? 'minimized' : ''}`}
      style={{ left: pos.x, top: pos.y, width: size.w, height: size.h, zIndex }}
      onMouseDown={() => onFocus(id)}
    >
      <div className="window-title" onMouseDown={onTitleDown}>
        <div className="window-dots-small">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <div className="window-title-text">{title}</div>
        <div className="window-controls">
          <button className="icon-btn" onClick={() => setIsMinimized(s => !s)}>{isMinimized ? '▢' : '▁'}</button>
          <button className="icon-btn" onClick={() => onClose(id)}>✕</button>
        </div>
      </div>

      {!isMinimized && (
        <div className="window-body">
          <iframe title={title} src={url} frameBorder="0" style={{width:'100%',height:'100%'}} sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation" onError={(e)=>{ /* if it fails, nothing to do here; some sites block framing */ }} />
        </div>
      )}

      <div className="resizer" onMouseDown={onResizeStart} />
    </div>
  );
}
